import React from "react";
import { useSelector } from "react-redux";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { selectState, setSelectedReversIndex } from "../main.slice";
import { IRevers } from "Dashboard/scenes/Resources/domain/IRevers";
import { useAppDispatch } from "hooks/hooks";
import InfoTooltip from "components/Popup/InfoTooltip";
import { MdDeleteForever } from "react-icons/md";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasFullAccessTo } from "utils/authUtil";
import { RESOURCES_MODULE_NAME } from "Dashboard/scenes/Resources/domain/ResourcesModule";

interface IProps {
  index: number;
  revers: IRevers;
  handleChargeSelect: Function;
  setPendingChargeToDelete: Function;
}

const ReversRow = ({
  index,
  revers,
  handleChargeSelect,
  setPendingChargeToDelete
}: IProps) => {
  const dispatch = useAppDispatch();
  const { selectedReversIndex } = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);

  return (
    <React.Fragment>
      <div
        className={`row ${selectedReversIndex === index ? 'active' : ""}`}
        onClick={() => dispatch(setSelectedReversIndex(index))}
      >
        <div className="col center">
          <div className="bg-item center">
            {revers.reversId}
          </div>
        </div>
        <div className="col center">
          <div className="bg-item">
            {revers.employeeName}
          </div>
        </div>
        <div className="col">
          <div className="bg-item overflowMinWidth center">
            <InfoTooltip tooltip={revers.projectName}
              classesProp="bg-text-overflow">
              {revers.projectName}
            </InfoTooltip>
          </div>
        </div>
      </div>

      {revers.charges.map((charge, chargeIndex) => (
        <div key={`subrow-${chargeIndex}`}
          className={`row row-sub ${revers.reversId ? "row-wo-check" : ""}
            ${selectedReversIndex === index ? "show" : "hide"}`}
        >
          {!revers.reversId &&
            <div className="col">
              {hasFullAccessTo(user, RESOURCES_MODULE_NAME)
                ? (<MdDeleteForever className="pointer" onClick={() => setPendingChargeToDelete(charge)} />)
                : (<span className="emptySpan"></span>)}
              <input
                type="checkbox"
                defaultChecked={!!charge.chargeId}
                onClick={(e) => {
                  e.stopPropagation();
                  handleChargeSelect(charge.chargeId);
                }}
              />
            </div>}
          <div className="col center">
            <div className="bg-item">
              {charge.resourceName} (id broj: {charge.resourceIdNumber ?? '-'}) {FormatNumberWithUnitOrNull(charge.quantity, 'kom')}
            </div>
          </div>
        </div>))}
    </React.Fragment>
  );
};

export default ReversRow;
